const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const formatPermission = (permission: string): string => {
  if (!permission) return '';
  
  // Split by dots
  const parts = permission.split('.');
  
  // Last part is usually the action (read, create, update, delete)
  const action = parts.pop() || '';
  
  // Remaining parts form the resource name
  let resource = parts.join(' ');
  
  // Replace underscores with spaces and capitalize each word
  resource = resource
    .replace(/_/g, ' ')
    .split(' ')
    .map(word => capitalize(word))
    .join(' ');

  const actionMap: Record<string, string> = {
    read: 'View',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
  };

  const formattedAction = actionMap[action] || capitalize(action);

  // If resource is empty, just return action
  if (!resource) return formattedAction;

  return `${formattedAction} ${resource}`;
};
